import { render, staticRenderFns } from "./CrmConversation.vue?vue&type=template&id=d40bb202"
import script from "./CrmConversation.vue?vue&type=script&lang=js"
export * from "./CrmConversation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports